import KlaviyoState from '../types/KlaviyoState'

export const state: KlaviyoState = {
  customer: null,
  isSubscribed: null,
  backInStockWatching: []
}
